// A client company's own people (routes/admin/team.ts on the API). Only the
// company's primary account may call these.
import api from './client';

export interface TeamMember {
  id: string;
  email: string;
  name: string | null;
  read_only: boolean;
  is_active: boolean;
  created_at: string;
}

export const listTeam = () => api.get<TeamMember[]>('/admin/team');

export const addTeamMember = (input: { email: string; name?: string; password: string; read_only?: boolean }) =>
  api.post<TeamMember>('/admin/team', input);

export const updateTeamMember = (id: string, input: { name?: string | null; read_only?: boolean; is_active?: boolean }) =>
  api.patch<TeamMember>(`/admin/team/${id}`, input);

export const resetTeamPassword = (id: string, password: string) =>
  api.post<{ ok: true }>(`/admin/team/${id}/password`, { password });
